import { LeaderboardTrialInvitesInfoModule } from './../leaderboard-trial-invites-info/leaderboard-trial-invites-info.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LoaderModule } from '@app/shared';
import { PipeModule } from '@app/shared';
import { FormsModule } from '@app/shared/forms';

import { LeaderboardPreviewGamificationComponent } from './leaderboard-preview-gamification.component';
import { LeaderboardItemComponent } from '../leaderboard-item/leaderboard-item.component';
import { FormDropdownModule } from '@app/tw-shared/forms/form-dropdown/form-dropdown.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbTooltipModule,
        TranslateModule,
        LeaderboardTrialInvitesInfoModule,
        InlineSVGModule,
        LoaderModule,
        PipeModule,
        FormsModule,
        LeaderboardItemComponent,
        FormDropdownModule,
    ],
    declarations: [LeaderboardPreviewGamificationComponent],
    exports: [LeaderboardPreviewGamificationComponent],
})
export class LeaderboardPreviewGamificationModule {}
